(function () {
    'use strict';

    angular
        .module('Lavpop-store.components')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController($rootScope) {
        const vm = this;

        init();

        function init() {
            $rootScope.addDivisor = false;
        }
    }
}());